import { render } from "./a-title.vue?vue&type=template&id=71799b53&scoped=true"
import script from "./a-title.vue?vue&type=script&lang=js"
export * from "./a-title.vue?vue&type=script&lang=js"

import "./a-title.vue?vue&type=style&index=0&id=71799b53&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71799b53"]])

export default __exports__